export default "__VITE_ASSET__51fc739f__"